import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Homepage from './Pages/Homepage';
import ContentContactUs from './Pages/ContactUs/ContentContactUs';
import ContentPakage from './Pages/PakagesCategory/ContentPakage';
import ContentAbout from './Pages/About/ContentAbout';
import ShowPakages from './Pages/PakagesCategory/AfterLogin/ShowPakages';
import TourPakagesContent from './Pages/TourPakages/TourPakagesContent';
import ContentHotelsGrid from './Pages/PakagesCategory/AfterLogin/HotelsDetailsPage/ContentHotelsGrid';
import PakageDetailsContent from './Pages/TourPakages/TourPakageDetailspage/PakageDetailsContent';
import PakageRegisterContent from './Pages/PakagesCategory/PakageRegister/PakageRegisterContent';
import HelpContent from './Pages/Help/HelpContent';
import InternationalContent from './Pages/PakagesCategory/InternationalPakageCategory/InternationalContent';
import ShowDomesticPakages from './Pages/PakagesCategory/AfterLogin/ShowDomesticPakages';
import ShowInternationalPakages from './Pages/PakagesCategory/AfterLogin/ShowInternationalPakages';
import ShowPanIndiaHotels from './Pages/PakagesCategory/AfterLogin/ShowPanIndiaHotels';
import ResetContent from './Pages/PakagesCategory/ResetContent';
import AccountContent from './Pages/PakagesCategory/AccountContent';
import ShowReligiousPakages from './Pages/PakagesCategory/AfterLogin/ShowReligiousPakages';
import ShowEuropePakages from './Pages/PakagesCategory/AfterLogin/ShowEuropePakages';
import DomesticFOrmContent from './Components/GroupRequest/Domestic/DomesticFormContent';
import InternationalFormContent from './Components/GroupRequest/International/InternationalFormContent';
import ReligiousFormContent from './Components/GroupRequest/Religious/ReligiousFormContent';
import InternationalSimContent from './Components/InternationalSim/InternationSimContent';
import RoundTripContent from './Components/RoundTrip/RoundTripContent';

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/contact-us" element={<ContentContactUs />} />
          <Route path="/login" element={<ContentPakage />} />
          <Route path="/reset-password" element={<ResetContent />} />
          <Route path="/account" element={<AccountContent />} />
          <Route path="/register" element={<PakageRegisterContent />} />
          <Route path="/about" element={<ContentAbout />} />
          <Route path="/pakages" element={<ShowPakages />} />
          <Route
            path=":category/tour-pakages"
            element={<TourPakagesContent />}
          />
          <Route
            path="/hotels/:sub_brand_name"
            element={<ContentHotelsGrid />}
          />
          <Route path="/package/:slug" element={<PakageDetailsContent />} />
          <Route path="/help" element={<HelpContent />} />
          <Route path="/domestic-pakages" element={<ShowDomesticPakages />} />
          <Route
            path="/international-pakages"
            element={<ShowInternationalPakages />}
          />
          <Route path="/religious-pakages" element={<ShowReligiousPakages />} />
          <Route path="/europe-pakages" element={<ShowEuropePakages />} />
          <Route path="/domestic-form" element={<DomesticFOrmContent />} />
          <Route
            path="/international-form"
            element={<InternationalFormContent />}
          />
          <Route path="/religious-form" element={<ReligiousFormContent />} />
          <Route
            path="/international-sim"
            element={<InternationalSimContent />}
          />
          <Route path="/round-trip" element={<RoundTripContent />} />

          <Route path="/pan-india-hotels" element={<ShowPanIndiaHotels />} />
          <Route
            path=":category/international-tour-pakages"
            element={<InternationalContent />}
          />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
